import { useQuery } from '@tanstack/react-query';

import axios from 'src/lib/axios';
import { type QueryConfig } from 'src/lib/react-query';
import { formatResourcePath } from 'src/utils/regex';

import type { PrepaidCard } from 'src/features/subscriptions/types';
import type { ListDTO } from 'src/types';

const RESOURCE = '/parkings/:parkingId/prepaid-card/:cardId/';

interface DTO extends ListDTO {
    parkingId: string;
    cardId: string;
}

type QueryFnType = typeof queryFn;
const queryFn = ({ parkingId, cardId, ...params }: DTO): Promise<PrepaidCard> => {
    return axios.get(formatResourcePath(RESOURCE, { parkingId, cardId }), { params });
};

interface UseQueryHookOptions extends DTO {
    config?: QueryConfig<QueryFnType>;
}
const useQueryHook = ({ config, ...payload }: UseQueryHookOptions) =>
    useQuery({
        queryKey: [RESOURCE, payload],
        queryFn: async () => await queryFn(payload),
        ...config,
    });

export { useQueryHook as useGetPrepaidCard };
